import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

interface UploadArgs {
  file: File;
}

/**
 * Laster opp et tilbud (PDF/PNG/JPG) til `offers`-bucket for senere
 * referanse. Non-blocking: brukes som "fire-and-forget" i `PdfOfferUpload`
 * mens AI-ekstraksjonen kjører i parallell. Feiler stille ved nettverks-
 * problemer — vi vil ikke at en arkiverings-feil skal blokkere selve
 * tilbuds-parsing-flyten.
 *
 * Mutation-mønsteret holder supabase-importen ute av komponentene
 * (CLAUDE.md regel 4).
 */
export function useUploadOfferFile() {
  return useMutation({
    mutationFn: async ({ file }: UploadArgs) => {
      const path = `offers/${Date.now()}_${file.name}`;
      const { error } = await supabase.storage.from("offers").upload(path, file);
      if (error) throw new Error(error.message);
      return { path };
    },
  });
}
